'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
function $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z($thiz, iter, o$2) {
  while (true) {
    if (iter.i()) {
      var a = iter.e();
      if ((!((a === null) ? (o$2 === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(a, o$2)))) {
        continue;
      }
      iter.rg();
      return true;
    } else {
      return false;
    }
  }
}
export { $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z as $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z };
/** @constructor */
function $c_ju_AbstractCollection() {
}
export { $c_ju_AbstractCollection as $c_ju_AbstractCollection };
$p = $c_ju_AbstractCollection.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_ju_AbstractCollection;
/** @constructor */
function $h_ju_AbstractCollection() {
}
export { $h_ju_AbstractCollection as $h_ju_AbstractCollection };
$h_ju_AbstractCollection.prototype = $p;
$p.k = (function() {
  return (this.T() === 0);
});
$p.ae = (function(o) {
  var _\uff3fself = this.cV();
  while (_\uff3fself.i()) {
    var t = _\uff3fself.e();
    if (((o === null) ? (t === null) : $j_java$002elang$002e$002dObject.$dp_equals__O__Z(o, t))) {
      return true;
    }
  }
  return false;
});
$p.CF = (function(a) {
  var toFill = ((a.a.length >= this.T()) ? a : $j_java$002elang$002e$002dObject.$objectGetClass(a).J.Q().J.U(this.T()));
  var iter = this.cV();
  var end = this.T();
  var i = 0;
  while ((i < end)) {
    var value = i;
    toFill.a[value] = iter.e();
    i = ((1 + i) | 0);
  }
  if ((toFill.a.length > this.T())) {
    toFill.a[this.T()] = null;
  }
  return toFill;
});
$p.la = (function(o) {
  return $p_ju_AbstractCollection__findAndRemove$1__ju_Iterator__O__Z(this, this.cV(), o);
});
$p.SX = (function(c) {
  var _\uff3fself = c.cV();
  _return: {
    while (_\uff3fself.i()) {
      if ((!this.ae(_\uff3fself.e()))) {
        var $x_1 = true;
        break _return;
      }
    }
    var $x_1 = false;
  }
  return (!$x_1);
});
$p.Xa = (function(c) {
  var iter = this.cV();
  var changed = false;
  while (iter.i()) {
    var t = iter.e();
    if ((!c.ae(t))) {
      iter.rg();
      changed = true;
    }
  }
  return changed;
});
$p.b = (function() {
  var _\uff3fself = this.cV();
  var result = "[";
  var first = true;
  while (_\uff3fself.i()) {
    if (first) {
      first = false;
    } else {
      result = (result + ", ");
    }
    result = (("" + result) + _\uff3fself.e());
  }
  return (result + "]");
});
